import React, { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import alephLogo from '../../assets/img/Aleph Logo.svg'
import lastFrameImg from '../../assets/img/last_frame.png'
import './Layout.css'

function getUserFirstName() {
  try {
    const stored = JSON.parse(localStorage.getItem('userData') || '{}')
    if (stored?.first_name) return stored.first_name
    if (stored?.name) return String(stored.name).split(' ')[0]
  } catch (e) {}
  return 'invitat'
}

function getUserAvatarUrl() {
  try {
    const stored = JSON.parse(localStorage.getItem('userData') || '{}')
    return stored?.avatar_url || null
  } catch (e) {}
  return null
}

const Layout = ({ children }) => {
  const navigate = useNavigate()
  const [userRefresh, setUserRefresh] = useState(0)
  
  const firstName = useMemo(() => getUserFirstName(), [userRefresh])
  const isLoggedIn = useMemo(() => !!localStorage.getItem('authToken'), [userRefresh])
  const avatarUrl = useMemo(() => getUserAvatarUrl(), [userRefresh])

  const handleLogout = () => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('userData')
    localStorage.removeItem('subscriptionId')
    localStorage.removeItem('subscriptionLevel')
    localStorage.removeItem('__paypal_storage__')
    navigate('/v4.0/login')
    window.location.reload()
  }

  const handleLogoClick = () => {
    navigate('/v4.0')
  }

  return (
    <div className="v4-layout-root" style={{ backgroundImage: `url(${lastFrameImg})` }}>
      <div className="v4-layout-overlay"></div>
      
      <header className="v4-layout-header">
        <div className="v4-layout-header-left" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          Pentru tine, <span>{firstName}</span>
        </div>
        <div className="v4-layout-header-center"></div>
        <div className="v4-layout-header-right">
          <img 
            src={alephLogo} 
            alt="Aleph" 
            className="v4-layout-logo" 
            onClick={handleLogoClick}
            style={{ cursor: 'pointer' }}
          />
          {isLoggedIn && (
            <>
              {avatarUrl ? (
                <button className="v4-layout-btn v4-layout-btn--avatar" onClick={() => navigate('/v4.0/account')} aria-label="Profilul meu" title="Profilul meu">
                  <img src={avatarUrl} alt="Profil" className="v4-layout-avatar" />
                </button>
              ) : (
                <button className="v4-layout-btn" onClick={() => navigate('/v4.0/account')} aria-label="Profilul meu" title="Profilul meu">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </button>
              )}
              <button className="v4-layout-btn" onClick={handleLogout} aria-label="Deconectare" title="Deconectare">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </button>
            </>
          )}
        </div>
      </header>

      <main className="v4-layout-content">
        {children}
      </main>
    </div>
  )
}

export default Layout

